module.exports = __webpack_public_path__ + "static/media/LOGO_SF.e0ea8f48.png";